import { MasteryLevel } from "../types/enums";
import type { SummaryStats } from "./types";

export const SUMMARY_LEVELS = [
  MasteryLevel.MASTERED,
  MasteryLevel.PROFICIENT,
  MasteryLevel.APPROACHING,
  MasteryLevel.NOT_STARTED,
] as const;

export function summaryDisplayStats(stats: SummaryStats): SummaryStats {
  if (stats.hasDirectEvidence !== false) return stats;
  return {
    ...stats,
    counts: {
      [MasteryLevel.MASTERED]: 0,
      [MasteryLevel.PROFICIENT]: 0,
      [MasteryLevel.APPROACHING]: 0,
      [MasteryLevel.NOT_STARTED]: stats.total,
    },
    started: 0,
    atLeast: 0,
    percent: null,
    points: null,
    status: MasteryLevel.NOT_STARTED,
    members: undefined,
  };
}
